module.exports = __webpack_public_path__ + "static/img/53-1.07b7409.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/53-1.jpg
// module id = zkbo
// module chunks = 0